export default {
  en: {
    google_unknown_error: 'Unknown error occured with Google Login. Please try again later.',
    facebook_unknown_error: 'Unknown error occured with Facebook Login. Please try again later.',
    unknown_server_error: 'We are currently experiencing technical issues. Please try again later.',
    login_error: 'Username or password is incorrect.',
    user_already_exists: 'A user with this email address already exists.'
  },
  es: {
    google_unknown_error: 'Unknown error occured with Google Login. Please try again later.',
    facebook_unknown_error: 'Unknown error occured with Facebook Login. Please try again later.',
    unknown_server_error: 'We are currently experiencing technical issues. Please try again later.',
    login_error: 'Username or password is incorrect.',
    user_already_exists: 'A user with this email address already exists.'
  }
};